import { createError } from './create-error';

export const IDBAccessError = createError(
  'IDBAccessError',
  'Failed to access database',
  {
    FAILED_TO_OPEN: 'Failed to open database connection.',
    FAILED_TO_GET_CLIENT_MAPPING: 'Failed to retrieve data (1)',
    FAILED_TO_STORE_CLIENT_MAPPING: 'Failed to store data (1)',
    FAILED_TO_STORE_TOPIC_MAPPING: 'Failed to store data (2)',
    FAILED_TO_DELETE_CLIENT_METADATA: 'Failed to delete data (1)',
    FAILED_TO_DELETE_CLIENT_SUBSCRIPTIONS: 'Failed to delete data (2)',
  } as const
);
